import v8n from 'v8n'
import validatorUtils from './validation_utils'

export default {
  create (data) {
    console.log(data)
    const schema = {
      name: v8n().not.null().string().minLength(2),
      lastName: v8n().not.null().string().minLength(2),
      email: v8n().not.null().validEmail(),
      phone: v8n().not.null().validPhone(),
    }
    // if (data.documentNumber) {
    //   schema.documentNumber = v8n().not.null().validCPForCNPJ()
    // }
    return v8n()
      .schema(schema)
      .testAsync(data)
      .then(() => ({ success: true }))
      .catch(e => validatorUtils.buildErrors('engagement', e))
  }
}
